import React, { useEffect } from "react";
import HeroProduct1 from "../../components/Produk/Produk1/HeroProduct1";
import HowItWorksProduct1 from "../../components/Produk/Produk1/HowItWorksProduct1";
import SuitForProduct1 from "../../components/Produk/Produk1/SuitForProduct1";
import PainPointProduct1 from "../../components/Produk/Produk1/PainPointProduct1";
import SolutionProduct1 from "../../components/Produk/Produk1/SolutionProduct1";
import ValueBenefitsProduct1 from "../../components/Produk/Produk1/ValueBenefitsProduct1";
import GuaranteeScoreProduct1 from "../../components/Produk/Produk1/GuaranteeScoreProduct1";
import BonusProduct1 from "../../components/Produk/Produk1/BonusProduct1";
import TestimonialsProduct1 from "../../components/Produk/Produk1/TestimonialsProduct1";
import PriceProduct1 from "../../components/Produk/Produk1/PriceProduct1";
import CTAProduct1 from "../../components/Produk/Produk1/CTAProduct1";


const Product1 = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen">
      <HeroProduct1 />
      <PainPointProduct1 />
      <SolutionProduct1 />
      <ValueBenefitsProduct1 />
      <GuaranteeScoreProduct1 />
      <TestimonialsProduct1 />
      <HowItWorksProduct1 />
      <SuitForProduct1 />
      <BonusProduct1 />
      <PriceProduct1 />
      <CTAProduct1 />
    </div>
  );
};

export default Product1;
